(function () {
  function getCanonicalBase() {
    let path = window.location.pathname;
    if (path.endsWith("/")) path = path.slice(0, -1);
    return window.location.origin + path;
  }

  function getPageFromURL(urlString) {
    const url = new URL(urlString, window.location.origin);
    return parseInt(url.searchParams.get("page")) || 1;
  }

  function ensureSingleCanonicalEl() {
    const els = document.querySelectorAll('link[rel="canonical"]');
    let el = els[0];
    if (!el) {
      el = document.createElement("link");
      el.setAttribute("rel", "canonical");
      document.head.appendChild(el);
    }
    for (let i = 1; i < els.length; i++) els[i].remove();
    return el;
  }

  function setCanonical(page) {
    const el = ensureSingleCanonicalEl();
    const base = getCanonicalBase();
    el.href = page <= 1 ? base : `${base}?page=${page}`;
  }

  function updateFromLocation() {
    setCanonical(getPageFromURL(window.location.href));
  }

  (function (history) {
    const pushState = history.pushState;
    const replaceState = history.replaceState;
    function fire() { window.dispatchEvent(new Event("locationchange")); }

    history.pushState = function () {
      const ret = pushState.apply(this, arguments);
      fire();
      return ret;
    };
    history.replaceState = function () {
      const ret = replaceState.apply(this, arguments);
      fire();
      return ret;
    };
    window.addEventListener("popstate", fire);
  })(window.history);

  document.addEventListener("DOMContentLoaded", updateFromLocation);

  window.addEventListener("locationchange", updateFromLocation);

  document.addEventListener("click", function (e) {
    const link = e.target.closest('a.pagination__item[is="facet-link"]');
    if (!link) return;
    setCanonical(getPageFromURL(link.href));
  });
})();
